import { SegmentSuggestions } from "../../../../../core/domain/models";
import { Mapper } from "../../../../../core/base";
import { GetSegmentSuggestionsWebEntity } from "./segment-suggestions-web-entity";

export class SegmentSuggestionMapper extends Mapper<GetSegmentSuggestionsWebEntity, SegmentSuggestions> {
    mapFrom(param: GetSegmentSuggestionsWebEntity): SegmentSuggestions {
      return {
        segment: param.segment,
        noOfLocations: param.noOfLocations,
        distance:param.distance,
        waypoints: param.waypoints ?? [],
        color: ''    
      };
    }
  
    mapTo(param: SegmentSuggestions): GetSegmentSuggestionsWebEntity {
      return {
          segment: param.segment,
          noOfLocations: param.noOfLocations,
          distance:param.distance,
          waypoints: param.waypoints ?? []
        };
    }
  }